<template>
  <div>
    <div v-if="showIrregularLogsMessage" class="mb-3 mx-3">
      <appIrregularMinutesLogsIcon :mandate-id="mandateId" />
    </div>

    <div v-for="(event, index) in mandateMinuteEvents" :key="index">
      <div class="position-relative d-inline-flex">
        <div class="d-flex align-items-center">
          <font-awesome-icon
            v-if="event.event == meetingMinutesNames.mandate_added"
            class="text-success mr-1"
            icon="sign-in-alt"
          />
          <font-awesome-icon
            v-else-if="event.event == meetingMinutesNames.mandate_moved"
            class="text-info mr-1"
            icon="share"
          />
          <font-awesome-icon
            v-else-if="event.event == meetingMinutesNames.mandate_left"
            class="text-danger mr-1"
            icon="sign-out-alt"
          />
          <!-- NOTE: DEV-4802 -> Display also not mandate related minutes  -->
          <font-awesome-icon
            v-else-if="event.event == meetingMinutesNames.participant_arrived"
            class="text-success mr-1"
            icon="sign-in-alt"
          />
          <font-awesome-icon
            v-else-if="event.event == meetingMinutesNames.participant_left"
            class="text-danger mr-1"
            icon="sign-out-alt"
          />

          <span :id="uniqId()" class="cursor-pointer" @click="attachTooltip($event, event)">
            {{ $moment(event.date).format("HH:mm:ss") }}
          </span>
        </div>

        <div class="ml-2 fw-700">
          <span
            v-if="
              event.event == meetingMinutesNames.mandate_added ||
              event.event == meetingMinutesNames.mandate_left
            "
          >
            <!-- NOTE: Display info of the Bo that is represented -->
            {{ getPersonNameAndGender(getBuildingOwnerInfo(event)) }}
          </span>
          <span v-else-if="event.event == meetingMinutesNames.mandate_moved">
            {{ getPersonNameAndGender(getOwnerOrContactMovedFromInfo(event)) }}
            <font-awesome-icon icon="long-arrow-alt-right" />
            {{ getPersonNameAndGender(getOwnerOrContactMovedToInfo(event)) }}
          </span>
          <span v-else-if="event.event == meetingMinutesNames.participant_arrived">
            {{ getPersonNameAndGender(getBuildingOwnerInfo(event)) }}
            {{ "(arrivée du participant)" }}
          </span>
          <span v-else-if="event.event == meetingMinutesNames.participant_left">
            {{ getPersonNameAndGender(getBuildingOwnerInfo(event)) }}
            {{ "(départ du participant)" }}
          </span>
        </div>

        <appRemoveMinuteEventIcon v-if="showIrregularLogsMessage" class="ml-2" :event="event" />
      </div>
    </div>
  </div>
</template>

<script>
import MeetingORM from "@/store/orm-axios/models/Meeting";

import minutesMixin from "@/mixins/minutes.js";

import appRemoveMinuteEventIcon from "@/components/snippets/RemoveMinuteEventIcon";
import appIrregularMinutesLogsIcon from "@/components/snippets/IrregularMinutesLogsIcon";

import appMeetingManualDatePicker from "@/components/fields/MeetingManualDatePicker";
import AppTooltip from "@/components/snippets/Tooltip";
import Vue from "vue";
var uuid = require("uuid");

import { meetingMinutesNames } from "@/constants/meeting.js";

export default {
  components: {
    appMeetingManualDatePicker,
    appRemoveMinuteEventIcon,
    appIrregularMinutesLogsIcon,
  },
  mixins: [minutesMixin],
  props: ["mandateId"],
  data() {
    return {
      meetingMinutesNames,
    };
  },
  computed: {
    meeting() {
      return MeetingORM.query().whereId(this.$route.params.id).first();
    },
    mandateMinuteEvents() {
      return this.$_.filter(this.meeting.minutes, minute => {
        return (
          (minute.event == this.meetingMinutesNames.mandate_added ||
            minute.event == this.meetingMinutesNames.mandate_moved ||
            minute.event == this.meetingMinutesNames.mandate_left ||
            minute.event == this.meetingMinutesNames.participant_arrived ||
            minute.event == this.meetingMinutesNames.participant_left) &&
          minute.mandate_id == this.mandateId
        );
      });
    },

    showIrregularLogsMessage() {
      const mandateAddedEvents = this.mandateMinuteEvents.filter(
        m => m.event == this.meetingMinutesNames.mandate_added
      );
      const mandateLeftEvents = this.mandateMinuteEvents.filter(
        m => m.event == this.meetingMinutesNames.mandate_left
      );

      return (
        mandateAddedEvents.length !== mandateLeftEvents.length &&
        mandateAddedEvents.length !== mandateLeftEvents.length + 1
      );
    },
  },
  methods: {
    getBuildingOwnerInfo(minuteEvent) {
      if (minuteEvent.representant_type == "owner" || minuteEvent.representant_type == "contact") {
        return { personId: minuteEvent.building_owner_id };
      }
    },
    getOwnerOrContactInfo(minuteEvent) {
      if (minuteEvent.representant_type == "owner") {
        return { personId: minuteEvent.representant_id };
      } else if (minuteEvent.representant_type == "contact") {
        return { personId: minuteEvent.representant_id, personType: "contact" };
      }
    },
    getOwnerOrContactMovedFromInfo(minuteEvent) {
      if (minuteEvent.move_from_representant_type == "owner") {
        return { personId: minuteEvent.move_from_representant_id };
      } else if (minuteEvent.move_from_representant_type == "contact") {
        return { personId: minuteEvent.move_from_representant_id, personType: "contact" };
      }
    },
    getOwnerOrContactMovedToInfo(minuteEvent) {
      if (minuteEvent.move_to_representant_type == "owner") {
        return { personId: minuteEvent.move_to_representant_id };
      } else if (minuteEvent.move_to_representant_type == "contact") {
        return { personId: minuteEvent.move_to_representant_id, personType: "contact" };
      }
    },
    attachTooltip(e, data) {
      const TooltipClass = Vue.extend(AppTooltip);
      const tooltipInstance = new TooltipClass({
        propsData: {
          event: data,
          id: e.target.id,
        },
      });
      tooltipInstance.$mount(e.target.parent);
      tooltipInstance.$on("change", changeEvent => {
        this.changeMinuteEventDate(changeEvent.newDate, changeEvent.minuteEvent).then(() => {
          tooltipInstance.$destroy();
        });
      });
      tooltipInstance.$on("destroy-tooltip", () => {
        tooltipInstance.$destroy();
      });
    },
    uniqId() {
      return uuid.v4();
    },
  },
};
</script>
